import React from "react";
import { useNavigate } from "react-router-dom";
import "../style.css";
import FulfilmentCard from "./card";
import moment from "moment";
import { FormattedMessage } from "react-intl";
import CircleButton from "../../vapor/circleButton";

const MonthList = props => {
  const {
    cardSelected,
    setFulfilmentAddDialog,
    setCardSelected,
    firstMonth,    
    month,
    fulfilments,
    setFulfilmentEditDialog,
    setFulfilmentRemoveDialog,
    customerId
  } = props;
  const navigate = useNavigate();
  const renderCards = () => {
    let items = [];
    fulfilments.map(fulfilment => {
      if (moment(fulfilment.fulfilmentDeadline).format("YYYYMM") === month) {
        return items.push(<FulfilmentCard
          isCardSelected={
            !customerId && cardSelected === fulfilment.fulfilmentId
          }
          setCardSelected={value => {
            if (!customerId) {
              setCardSelected(value);
            } else {
              navigate("/fulfilments/activities/" +
                  fulfilment.fulfilmentId +
                  "?customer=" +
                  customerId);
            }
          }}
          fulfilment={fulfilment}
          isCustomerPage={customerId || false}
          activitiesBar={customerId || false}
          pointer={customerId || false}
          key={"dbx-fulfilment-card_" + fulfilment.fulfilmentId}
          setFulfilmentEditDialog={setFulfilmentEditDialog}
          setFulfilmentRemoveDialog={setFulfilmentRemoveDialog}
        />);
      }
      return null;
    });
    return items;
  };

  const itemsToRender = renderCards();

  if (itemsToRender.length === 0) {
    return null;
  }

  return (
    <div
      style={{ display: "flex", flexDirection: "column", width: "100%" }}
      key={"dbx-fulfilments-section_" + month}
      id={"dbx-fulfilments-section_" + month}
    >
      <div
        className={"month-title" + (month === firstMonth ? " firstMonth" : "")}
        key={"dbx-fulfilments-section-title_" + month}
        id={"dbx-fulfilments-section-title_" + month}
      >
        <FormattedMessage id={"generic.months." + month.substr(4, 2)} />
      </div>
      <div className={"fulfilment-card-container"}>
        {itemsToRender}
        {month && parseInt(month) >= parseInt(moment().format("YYYYMM")) && (
          <div className="fulfilment-list-card-add-button">
            <CircleButton
              tooltip={<FormattedMessage id="fulfilments.list.addButton" />}
              onClick={() => setFulfilmentAddDialog(month)}
              icon={["far", "plus"]}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default MonthList;
